<script setup>
import Header from '../Formularios/Header.vue'
import Intro from '../Formularios/Intro.vue'
import { useForm } from '@inertiajs/inertia-vue3';
</script>
<template>
    <Header :servicio="servicio" />
    <div class="contenido-wrapper">
        <Intro :servicio="servicio" />
        <div class="bloque-general pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <form @submit.prevent="submit()">
                            <h2>Tus Datos</h2>
                            <div class="form-group mt-4">
                                <div style="cursor: pointer;">
                                    <input style="cursor: pointer;" v-model="anonimo" type="checkbox" id="anonimo" @change="changeAnonimo">
                                    <label style="cursor: pointer;display:inline;" for="anonimo">Quiero denunciar de forma anónima</label>
                                </div>
                            </div>
                            <div class="row" v-if="!anonimo">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.nombre }">
                                        <label>Nombre(s) <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.nombre" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Paterno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_paterno" type="text" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.apellido_paterno }">
                                        <label>Apellido Materno <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.apellido_materno" type="text" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <p style="color: red;line-height: 1rem;" v-if="anonimo">El teléfono celular y correo electrónico son indispensables para dar seguimiento a la queja o denuncia.</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.email }">
                                        <label>Correo electrónico <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.email" type="email" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.telefono }">
                                        <label>Teléfono celular <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.telefono" type="tel" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.edad }">
                                        <label>Edad <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input type="number" min="0" v-model="form.edad" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.sexo }">
                                        <label>Sexo <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <select v-model="form.sexo" class="form-control form__select">
                                            <option value="Hombre">Hombre</option>
                                            <option value="Mujer">Mujer</option>
                                            <option value="Otro">Otro</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.domicilio }">
                                <label>Domicilio <small>(calle, número, colonia, código postal, municipio)</small> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <input v-model="form.domicilio" type="text" class="form-control">
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.nombre_padre_o_madre_o_tutor }">
                                        <label>Nombe del Padre, Madre o Tutor <small>(en caso de menor de edad)</small></label>
                                        <input v-model="form.nombre_padre_o_madre_o_tutor" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.tipo_de_vulneracion }">
                                        <label>Tipo de Vulneración <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <select v-model="form.tipo_de_vulneracion" class="form-control form__select">
                                            <option value="Ausentismo escolar">Ausentismo escolar</option>
                                            <option value="Maltrato">Maltrato</option>
                                            <option value="Higienes">Higienes</option>
                                            <option value="Descuido">Descuido</option>
                                            <option value="Trabajo infantil">Trabajo infantil</option>
                                            <option value="Otro">Otro</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.fecha }">
                                        <label>Fecha <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input type="date" v-model="form.fecha" class="form-control">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'not-valid': form.errors.lugar_de_los_hechos }">
                                        <label>Lugar de los hechos<span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                        <input v-model="form.lugar_de_los_hechos" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" v-if="form.tipo_de_vulneracion=='Otro'">
                                <label>¿Cual otro tipo de vulneración?<span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <input v-model="form.otro_tipo" class="form-control">
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.descripcion_de_la_situacion }">
                                <label>Descripción de la situación. <small>(explica de manera detallada la situación de la vulneración)</small><span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                <textarea v-model="form.descripcion_de_la_situacion" class="form-control" rows="5"></textarea>
                            </div>
                            <h2>Adjunta la siguiente documentación opcional:</h2>
                            <p>Puedes subir máximo 3 documentos opcionales (fotografías, archivos en pdf, word) que ayuden en el seguimiento de la queja.</p>
                            <div class="form-group border-bottom-1 mb-5" :class="{ 'not-valid': form.errors.archivo_1 }">
                                <p class="mb-2">Archivo 1 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_1 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_1">
                                    <label class="custom-file-label" for="archivo_1" data-txt-button="Selecciona un archivo">{{ (form.archivo_1) ? form.archivo_1.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>
                            <div class="form-group mb-5" :class="{ 'not-valid': form.errors.archivo_2 }">
                                <p class="mb-2">Archivo 2 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_2 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_2">
                                    <label class="custom-file-label" for="archivo_2" data-txt-button="Selecciona un archivo">{{ (form.archivo_2) ? form.archivo_2.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>
                            <div class="form-group" :class="{ 'not-valid': form.errors.archivo_3 }">
                                <p class="mb-2">Archivo 3 <br><small>Máximo 3MB, Sólo archivos JPG, PNG, GIF, PDF, WORD</small></p>
                                <div class="custom-file">
                                    <input @input="form.archivo_3 = $event.target.files[0]" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx" type="file" class="custom-file-input" id="archivo_3">
                                    <label class="custom-file-label" for="archivo_3" data-txt-button="Selecciona un archivo">{{ (form.archivo_3) ? form.archivo_3.name : 'No se ha seleccionado archivo' }}</label>
                                </div>
                            </div>

                            <div class="form-group mt-4" :class="{ 'not-valid': form.errors.aviso_de_privacidad }">
                                <div style="cursor: pointer;">
                                    <input style="cursor: pointer;" v-model="form.aviso_de_privacidad" type="checkbox" id="aviso_de_privacidad">
                                    <label style="display:inline;" for="aviso_de_privacidad">Confirmo que he leído y acepto el <a href="/descargas/avisodeprivacidad.pdf" style="text-decoration: underline;" target="_blank">Aviso de Privacidad</a> <span style="color: red;font-size: 29px;line-height: 0;">*</span></label>
                                </div>
                            </div>
                            <div class="form-group-submit">
                                <div class="response-output show" v-if="form.hasErrors">
                                    <p>Por favor completa los campos faltantes</p>
                                    <ul>
                                        <li v-for="(error, i) in form.errors" :key="i">{{ error }}</li>
                                    </ul>
                                </div>
                                <button type="submit" :disabled="form.processing">{{ (form.processing) ? 'Enviando ...' :
                                    'Solicitar trámite'
                                }}</button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        servicio: Object,
    },
    data() {
        return {
            anonimo: false,
            form: useForm({
                aviso_de_privacidad: false,
                servicio_id: this.servicio.id,
                slug: this.servicio.slug,
                nombre: '',
                apellido_paterno: '',
                apellido_materno: '',
                telefono: '',
                email: '',
                edad: '',
                sexo: 'Hombre',
                domicilio: '',
                nombre_padre_o_madre_o_tutor: '',
                tipo_de_vulneracion: 'Ausentismo escolar',
                fecha: '',
                otro_tipo: '',
                descripcion_de_la_situacion: '',
                lugar_de_los_hechos: '',
                archivo_1: '',
                archivo_2: '',
                archivo_3: '',
            }),
        }
    },
    methods: {
        submit() {
            this.form.post(route('servicios.formulario.save'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
        changeAnonimo(){
            if(this.anonimo){
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = 'Anónimo';
            }else{
                this.form.nombre = this.form.apellido_paterno = this.form.apellido_materno = '';
            }
        }
    }
}
</script>
<style scoped>
.pre {
    white-space: break-spaces;
}

.form-group.not-valid select, .form-group.not-valid textarea {
    border-color: #CD1518;
}
</style>
